import { NavLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './NavBar.css';

export default function NavBar() {
  const { logout } = useAuth();

  return (
    <nav className='navbar'>
      <NavLink to='/' className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
        🗺️<span>Карта</span>
      </NavLink>
      <NavLink to='/profile' className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
        👤<span>Профиль</span>
      </NavLink>
      <button className='nav-item nav-logout' onClick={logout}>
        🚪<span>Выйти</span>
      </button>
    </nav>
  );
}
